import tokens from "@sage/design-tokens/js/base/common";
export default (color => {
  if (color.startsWith("var")) {
    return tokens[color.replace("var(--", "").replace(")", "")];
  }
  return color;
});